import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { getTestIds } from '../../utils/TestIds';
import { useBiAction } from '../BiTracking';
import { Box } from '../Layout/Box';
import { pointOf, swipeDirectionOf } from './SwipeArea.utils';
export const GetSwipeAreaTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const SwipeArea = (param)=>{
    let { onSwipe, children, className, testId, bi } = param;
    const { SwipeAreaTestIds } = GetSwipeAreaTID(testId);
    const start = useRef(null);
    const logBiAction = useBiAction();
    const handleTouchStart = (event)=>{
        start.current = event.touches.length === 1 ? pointOf(event.touches[0]) : null;
    };
    const handleTouchEnd = (event)=>{
        const direction = start.current == null ? null : swipeDirectionOf(start.current, pointOf(event.changedTouches[0]));
        start.current = null;
        if (direction == null) return;
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'swipe_area',
                entityName: bi.name,
                actionType: 'select',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : '',
                    direction
                })
            });
        }
        onSwipe(direction);
    };
    return /*#__PURE__*/ _jsx(Box, {
        className: className,
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        testId: SwipeAreaTestIds.Root(),
        children: children
    });
};
